// extracted by mini-css-extract-plugin
export var currencyInput = "_na-1";
export var currencySymbol = "_na-0";